import { i18nTime } from '@affine/i18n';

const ROWS_PER_STEP = 60;

/** Today's changes show their time, older ones their day. */
export function changedLabel(changed: number, now = Date.now()) {
  const day = new Date(changed);
  const today = new Date(now);
  if (day.toDateString() === today.toDateString())
    return i18nTime(changed, {
      now,
      absolute: { accuracy: 'minute', noDate: true },
    });
  return i18nTime(changed, {
    now,
    absolute: {
      accuracy: 'day',
      noYear: day.getFullYear() === today.getFullYear(),
    },
  });
}

/** How many of `total` rows a list shows after it reached its end `steps` times. */
export function rowsShown(total: number, steps: number) {
  return Math.min(total, (steps + 1) * ROWS_PER_STEP);
}
